import { planService } from '../../../services/plan.service.js';
import { store } from '../../store.js';

const dispatch = store.dispatch;

export async function getAllPlans() {
    try {
        const data = await planService.getListPlans();
        return data;
    } catch (error) {
        console.error('Erro ao buscar todos os planos:', error);
        throw error;
    }
}

export async function getActivePlans() {
    try {
        const data = await planService.getPlansActive();
        return data;
    } catch (error) {
        console.error('Erro ao buscar planos ativos:', error);
        throw error;
    }
}

export async function getPlanByAccountId(id) {
    try {
        const data = await planService.getPlanForAccountId(id);
        return data;
    } catch (error) {
        console.error('Erro ao buscar plano account:', error);
        throw error;
    }
}
